import gql from "graphql-tag";
import { toast } from "react-toastify";

import { sentryWrappedException } from "~/utils/Utils";
import getQuery from "../utils/get_query";
import ParcisionCookies from "../../../utils/Cookies";

export default async function confirmPeraUpdatePortfolioRequest(
  decodedResult: string,
  pid: number,
  phash: string,
  pverified: boolean,
  rhash: string,
  rverified: boolean,
  description: string
) {
  try {
    const decodedResultTxn1 = decodedResult;

    const address = ParcisionCookies.get("address");
    const variables = {
      decodedResultTxn1,
      pid,
      phash,
      pverified,
      rhash,
      rverified,
      description,
      address,
    };

    const query = gql`
      query MyQuery(
        $decodedResultTxn1: String!
        $pid: Float!
        $phash: String!
        $pverified: Boolean!
        $rhash: String!
        $rverified: Boolean!
        $description: String!
        $address: String!
      ) {
        confirmPeraUpdatePortfolioRequest(
          decodedResultTxn1: $decodedResultTxn1
          pid: $pid
          phash: $phash
          pverified: $pverified
          rhash: $rhash
          rverified: $rverified
          description: $description
          address: $address
        ) {
          message
        }
      }
    `;

    const data = await getQuery(query, variables);
    // @ts-expect-error
    return data.confirmPeraUpdatePortfolioRequest;
  } catch (error) {
    toast.error("Failed to confirm bid request");
    sentryWrappedException(error);
    throw error;
  }
}
